export const postalCodePattern = '[0-9]{10}';

export const phoneNumberPattern = '^(00989|989|09|۰۰۹۸۹|۹۸۹|۰۹)[0-9,۰-۹]{9}$';

export const phoneNumberRegex = new RegExp(phoneNumberPattern);

export const localPhoneNumberPattern = '^0\\d{10}$';

export const phoneNumberPatternWithZero = '^09\\d{9}$';

export const socialNetworkIdPattern = '@?[a-zA-Z0-9_]+';
